import { useQuery } from "react-query";
import { getData } from "../newApis/apiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

const getAllApprovableBatchRepayment = async ({ Page, PageSize }) => {
  let queryParams = `Page=${Page}&PageSize=${PageSize}`;

  const data = await getData(
    `${ajaxEndpoints.GET_APPROVABLE_BATCH_LOAN_REPAYMENT}?${queryParams}`
  );
  return data;
};

export default function useAllApprovableBatchRepayment({ Page, PageSize }) {
  return useQuery(
    [{ Page, PageSize }, "getAllApprovableBatchRepayment"],
    getAllApprovableBatchRepayment
  );
}
